<template>
  <div class="datetime_picker">
    <DatePicker
      ref="datePicker"
      :value="selectedDate"
      :minDate="minDate"
      :maxDate="maxDate"
      width="150px"
      @change="onChangeDate"
    />
    <TimePicker
      ref="timePicker"
      :value="selectedDate"
      :minDate="minDate"
      :maxDate="maxDate"
      :displayTime="displayTime"
      :timeUnit="timeUnit"
      :defaultTime="defaultTime"
      @change="onChangeTime"
      class="blank"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Date, Number, String],
      default() {
        return new Date();
      }
    },
    minDate: {
      type: [Date, Number, String],
      default() {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 10);
        return date;
      }
    },
    maxDate: {
      type: [Date, Number, String],
      default() {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        return date;
      }
    },
    displayTime: {
      type: String,
      default: "00:00~24:00"
    },
    timeUnit: {
      type: Number,
      default: 30
    },
    defaultTime: String
  },
  data() {
    const selectedDate = new Date(this.value);
    return {
      selectedDate
    };
  },
  watch: {
    selectedDate(date) {
      this.$emit("change", date);
    }
  },
  methods: {
    onChangeDate(date) {
      let selectedDate = new Date(date);
      const timeDate = this.$refs.timePicker.getDate();
      selectedDate.setHours(timeDate.getHours(), timeDate.getMinutes(), 0, 0);
      if (selectedDate < this.minDate) {
        selectedDate = new Date(this.minDate);
        selectedDate.setMinutes(
          Math.ceil(selectedDate.getMinutes() / this.timeUnit) * this.timeUnit,
          0,
          0
        );
      }
      if (selectedDate > this.maxDate) {
        selectedDate = new Date(this.maxDate);
        selectedDate.setMinutes(
          Math.floor(selectedDate.getMinutes() / this.timeUnit) * this.timeUnit,
          0,
          0
        );
      }
      this.selectedDate = selectedDate;
    },
    onChangeTime(date) {
      this.selectedDate = date;
    },
    getDate() {
      return this.$refs.timePicker.getDate();
    }
  },
  mounted() {
    window.dd = this;
  }
};
</script>
